/**
 * SiteContactFieldButton - Site Contact field button using existing hooks
 */

import {useSiteContact} from '@hconnect/tuc-processes/fields/siteContact/useSiteContact'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {phoneNumberToString} from '../../../../../orderIntake/utils/phoneNumberUtils'
import {FieldButton} from '../../FieldButton'

interface SiteContactFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const SiteContactFieldButton: React.FC<SiteContactFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {name, phoneNumber} = useSiteContact()

  // Format display value: "Name - Phone" or just one if other is empty
  const formattedName = name?.trim() || null
  const formattedPhone = phoneNumber ? phoneNumberToString(phoneNumber) : null

  const displayValue = (() => {
    if (formattedName && formattedPhone) {
      return `${formattedName} - ${formattedPhone}`
    }
    return formattedName || formattedPhone || null
  })()

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.siteContact', 'Site contact')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
